{
  "common": {
    "networkError": "Erreur réseau — vérifiez la connexion",
    "retry": "Réessayer",
    "cancel": "Annuler",
    "close": "Fermer",
    "delete": "Supprimer",
    "prev": "Précédent",
    "next": "Suivant"
  },
  "statusLabels": {
    "pending": "En attente",
    "active": "Active",
    "failed": "Échouée",
    "removing": "Suppression"
  },
  "healthLabels": {
    "healthy": "saine",
    "degraded": "dégradée",
    "down": "hors service"
  },
  "header": {
    "title": "Marques de la plateforme",
    "description": "Exploitation multi-marque : chaque marque dispose d'un site marketing, d'une identité d'expéditeur ESP et (en option) d'un domaine externe personnalisé (Caddy + auto-ACME Let's Encrypt, vérification CNAME 48h, délai de grâce de suppression 30j).",
    "reservedBtn": "Voir les sous-domaines réservés",
    "newBtn": "+ Nouvelle marque"
  },
  "filter": {
    "searchPlaceholder": "Rechercher par nom ou domaine…",
    "statusLabel": "Statut",
    "statusAll": "Tous"
  },
  "list": {
    "aria": "Liste des marques",
    "loading": "Chargement des marques…",
    "loadFail": "Échec du chargement : {{message}}",
    "empty": "Aucune marque pour l'instant — cliquez sur « + Nouvelle marque » pour créer la marque par défaut.",
    "defaultBadge": "Par défaut",
    "merchantsHealth_one": "{{count}} marchand · état {{health}}",
    "merchantsHealth_other": "{{count}} marchands · état {{health}}",
    "verifyBtn": "Vérifier",
    "deleteBtn": "Supprimer",
    "pagination": "Page {{page}} · {{total}} au total"
  },
  "detail": {
    "aria": "Détail de la marque",
    "empty": "Sélectionnez une marque à gauche pour voir les détails, suivre la vérification DNS ou gérer l'identité d'expéditeur.",
    "loading": "Chargement de la marque…",
    "loadFail": "Échec du chargement de la marque.",
    "slugLabel": "slug",
    "editBtn": "Modifier",
    "closeBtn": "Fermer",
    "sectionsAria": "Sections de la marque",
    "tabOverview": "Aperçu",
    "tabVerify": "Vérifier le DNS",
    "tabSender": "Identité d'expéditeur",
    "fields": {
      "status": "Statut",
      "tagline": "Slogan",
      "primaryColor": "Couleur principale",
      "supportEmail": "E-mail de support",
      "termsUrl": "URL des conditions",
      "privacyUrl": "URL de confidentialité"
    }
  },
  "toast": {
    "loadDetailFailTitle": "Échec du chargement du détail de la marque",
    "brandInUseTitle": "La marque est utilisée par des marchands",
    "brandInUseDesc_one": "{{count}} marchand référence la marque « {{name}} ». Veuillez réaffecter avant de supprimer.",
    "brandInUseDesc_other": "{{count}} marchands référencent la marque « {{name}} ». Veuillez réaffecter avant de supprimer.",
    "deletedTitle": "Marque supprimée",
    "deleteFailTitle": "Échec de la suppression de la marque",
    "reassignReasonRequiredTitle": "Motif de réaffectation requis",
    "reassignReasonRequiredDesc": "Le motif doit comporter au moins 5 caractères.",
    "reassignSameTitle": "Cible identique à la source",
    "reassignSameDesc": "Choisissez une marque cible différente de la marque source.",
    "reassignSuccessTitle_one": "{{count}} marchand réaffecté",
    "reassignSuccessTitle_other": "{{count}} marchands réaffectés",
    "reassignFailTitle": "Échec de la réaffectation"
  },
  "deleteDialog": {
    "title": "Supprimer la marque ?",
    "description": "Supprimer « {{name}} ». Si des marchands référencent encore cette marque, le système exigera d'abord une réaffectation. Un délai de grâce de suppression de 30 jours s'applique aux enregistrements DNS."
  },
  "reassign": {
    "title": "Réaffecter les marchands rattachés",
    "intro_one": "{{count}} marchand est rattaché à la marque « {{name}} ». Choisissez une marque cible et un motif de réaffectation.",
    "intro_other": "{{count}} marchands sont rattachés à la marque « {{name}} ». Choisissez une marque cible et un motif de réaffectation.",
    "targetLabel": "Marque cible",
    "targetPlaceholder": "— sélectionner une marque —",
    "reasonLabel": "Motif (≥5 caractères)",
    "submit": "Réaffecter",
    "submitting": "Réaffectation…"
  },
  "reserved": {
    "title": "Sous-domaines réservés",
    "description": "Les slugs ci-dessous sont bloqués lors de la création d'une nouvelle marque. Le backend applique la même liste (VG_DOMAIN_RESERVED). Mettez à jour les deux endroits lors de l'ajout d'un nouveau slug."
  },
  "form": {
    "titleCreate": "Nouvelle marque de plateforme",
    "titleEdit": "Modifier la marque",
    "stepsAria": "Étapes de l'assistant",
    "themeDefaultName": "Nouvelle marque",
    "steps": {
      "identity": "Identité",
      "domain": "Domaine",
      "visual": "Visuel",
      "legal": "Légal",
      "confirm": "Confirmer"
    },
    "fields": {
      "displayName": "Nom d'affichage de la marque",
      "slug": "Slug de la marque",
      "slugHint": "Slug utilisé pour les URL internes. La liste réservée s'applique.",
      "slugImmutable": "Slug non modifiable",
      "reservedChip": "Réservé",
      "reservedChipTitle": "« {{slug}} » est un sous-domaine réservé.",
      "tagline": "Slogan",
      "description": "Description",
      "primaryDomain": "Domaine principal",
      "primaryDomainPlaceholder": "premium.example.com",
      "additionalDomains": "Domaines supplémentaires",
      "additionalDomainsHint": "Un domaine par ligne (ou séparés par des virgules).",
      "logoUrl": "URL du logo",
      "primaryColor": "Couleur principale",
      "secondaryColor": "Couleur secondaire",
      "legalEntityName": "Nom de l'entité juridique",
      "legalAddress": "Adresse légale",
      "supportEmail": "E-mail de support",
      "termsUrl": "URL des conditions",
      "privacyUrl": "URL de confidentialité"
    },
    "confirm": {
      "heading": "Vérifier & confirmer",
      "note": "Après la création, le système lance le cycle de vérification CNAME (Caddy + auto-ACME, délai de 48h selon NG-19). La marque est redirigée vers la page de vérification DNS.",
      "displayName": "Nom d'affichage",
      "slug": "Slug",
      "primaryDomain": "Domaine principal",
      "primaryColor": "Couleur principale",
      "supportEmail": "E-mail de support"
    },
    "validation": {
      "slugFormat": "Le slug ne peut contenir que a-z, 0-9 et des tirets.",
      "slugReserved": "Le slug figure dans la liste réservée.",
      "domainInvalid": "Domaine invalide."
    },
    "btn": {
      "back": "Retour",
      "next": "Suivant",
      "saving": "Enregistrement…",
      "saveChanges": "Enregistrer les modifications",
      "createBrand": "Créer la marque"
    },
    "toast": {
      "formHasErrorsTitle": "Le formulaire contient des erreurs",
      "formHasErrorsDesc": "Veuillez revenir aux étapes précédentes et vérifier.",
      "updatedTitle": "Marque mise à jour",
      "createdTitle": "Marque créée — passage à la vérification DNS",
      "updateFailTitle": "Échec de la mise à jour de la marque",
      "createFailTitle": "Échec de la création de la marque"
    }
  },
  "verify": {
    "aria": "Panneau de vérification DNS",
    "title": "Vérification DNS",
    "description": "Caddy + auto-ACME (Let's Encrypt) délivrera automatiquement un certificat SSL une fois le CNAME vérifié.",
    "cnameHeading": "Enregistrement CNAME à créer :",
    "type": "Type",
    "name": "Name",
    "value": "Value",
    "ttl": "TTL",
    "domainFallback": "(domaine de la marque)",
    "verifiedAt": "Vérifié le {{date}}",
    "lastFailed": "La dernière vérification a échoué. Vérifiez le CNAME et réessayez.",
    "waiting": "En attente de vérification…",
    "overdue": "Délai de 48h dépassé",
    "countdown": "{{hours}}h {{minutes}}m restantes",
    "recheckBtn": "Revérifier maintenant",
    "rechecking": "Vérification…",
    "guideSummary": "Guides par fournisseur DNS",
    "guideCloudflare": "Cloudflare — créer un enregistrement CNAME",
    "guideGoDaddy": "GoDaddy — ajouter un enregistrement CNAME",
    "guideNamecheap": "Namecheap — créer un enregistrement CNAME",
    "toast": {
      "verifiedTitle": "CNAME vérifié avec succès",
      "notMatchedTitle": "Le CNAME ne correspond pas encore",
      "observed": "Observé : {{target}}",
      "noRecord": "Aucun enregistrement CNAME trouvé pour l'instant. Veuillez vérifier votre fournisseur DNS.",
      "checkFailTitle": "Échec de la vérification DNS"
    }
  },
  "sender": {
    "aria": "Identité d'expéditeur",
    "title": "Identité d'expéditeur (SPF / DKIM / DMARC)",
    "description": "Les e-mails de cette marque doivent passer l'alignement DMARC. Gérez les alias en détail dans le module Sender Identities (task-44).",
    "manageBtn": "Gérer les identités d'expéditeur →",
    "loading": "Chargement des identités d'expéditeur…",
    "empty": "Aucune identité d'expéditeur pour cette marque. Créez un alias depuis le module Sender Identities pour le voir ici.",
    "replyToProvider": "reply-to {{replyTo}} · fournisseur {{provider}}",
    "table": {
      "type": "Type",
      "name": "Name",
      "value": "Value"
    },
    "statusLabels": {
      "pending": "En attente",
      "verified": "Vérifiée",
      "failed": "Échouée"
    }
  },
  "theme": {
    "aria": "Aperçu du thème",
    "title": "Aperçu en direct",
    "scope": "Portée",
    "untitled": "Marque sans nom",
    "startNow": "Commencer",
    "note": "L'aperçu en direct n'affiche que l'en-tête — la page marketing complète apparaît lorsque task-65 (middleware de la page d'accueil) livre la route"
  }
}
